import React from 'react';
import { CalendarIcon } from 'lucide-react';
export function LeaguesEvents() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#f8f6f0'
  }} aria-label="Leagues and Events" data-id="element-301">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-302">
        <div className="text-center mb-12" data-id="element-303">
          <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-304">
            Year-Round Programming
          </p>
          <h2 className="text-3xl md:text-4xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-305">
            Leagues &amp; Events
          </h2>
          <div className="section-divider-center" data-id="element-306" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-307">
          {/* Left column */}
          <div className="rounded-2xl p-6 md:p-8" style={{
          backgroundColor: '#ffffff',
          border: '1px solid #ede9e0',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }} data-id="element-308">
            <h3 className="text-lg font-bold uppercase mb-5 pb-3" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f',
            borderBottom: '2px solid #c8a84b'
          }} data-id="element-309">
              Leagues &amp; Regular Shoots
            </h3>
            <ul className="space-y-3" data-id="element-310">
              {['Jr Small Bore Rifle League', 'Fall Indoor PPC League', 'Winter Indoor PPC League', 'Sporting Clays Public Access', 'Bowling Pin .22 Shoots', 'New Shooter Nights – All Leagues', 'PPC Tournaments'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-311">
                  <div className="w-2 h-2 rounded-full flex-shrink-0" style={{
                backgroundColor: '#c8a84b'
              }} data-id="element-312" />
                  <span className="text-sm" style={{
                color: '#3a3a3a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-313">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right column */}
          <div className="rounded-2xl p-6 md:p-8" style={{
          backgroundColor: '#ffffff',
          border: '1px solid #ede9e0',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }} data-id="element-314">
            <h3 className="text-lg font-bold uppercase mb-5 pb-3" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f',
            borderBottom: '2px solid #c8a84b'
          }} data-id="element-315">
              Special Events &amp; Competitions
            </h3>
            <ul className="space-y-3" data-id="element-316">
              {['Cowboy Action Shoots – SASS', 'Club Top Gun Shoot Out', 'Sporting Clays Tournaments', 'Hunter Sight-In Days', 'Periodic Various Fun Shoots', 'Annual Member Banquet', 'Summer .22 Pistol Shoots'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-317">
                  <div className="w-2 h-2 rounded-full flex-shrink-0" style={{
                backgroundColor: '#c8a84b'
              }} data-id="element-318" />
                  <span className="text-sm" style={{
                color: '#3a3a3a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-319">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8 text-center" data-id="element-320">
          <a href="/10.html" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
          backgroundColor: '#1e3d2f',
          color: '#ffffff',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-321">
            <CalendarIcon size={16} data-id="element-322" />
            View Full Calendar
          </a>
        </div>
      </div>
    </section>;
}